import { PREVIOUS_PATH_KEY } from "@src/constants/sessionStorage-constants";
import { useEffect, useState } from "react";

export function usePersistedFilters<T>(key: string, initial: T) {
  const [filters, setFilters] = useState<T>(() => {
    if (typeof window === "undefined") return initial;
    const raw = sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : initial;
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(key, JSON.stringify(filters));
    }
  }, [key, filters]);

  const resetFilters = () => {
    sessionStorage.removeItem(key);
    setFilters(initial);
  };

  return { filters, setFilters, resetFilters };
}

export function resetAllFilters() {
  sessionStorage.removeItem(PREVIOUS_PATH_KEY);
  Object.keys(sessionStorage).forEach(key => {
    if (key.endsWith("-filters")) {
      sessionStorage.removeItem(key);
    }
  });
}
